/**
 * ISO 8601 week number for a given date.
 * Returns 1-53.
 */
export function isoWeek(d: Date): number {
  const target = new Date(d.valueOf());
  const dayNr = (d.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setMonth(0, 1);
  if (target.getDay() !== 4) {
    target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
  }
  return 1 + Math.ceil((firstThursday - target.valueOf()) / (7 * 24 * 3600 * 1000));
}

/**
 * Returns the ISO weeks (with Monday-Sunday range labels) that have at least
 * one day inside the given month (yyyymm = "YYYY-MM").
 */
export function isoWeeksInMonth(yyyymm: string): { week: number; rangeLabel: string }[] {
  const match = /^(\d{4})-(0[1-9]|1[0-2])$/.exec(yyyymm);
  if (!match) return [];
  const y = Number(match[1]);
  const m = Number(match[2]);
  const start = new Date(y, m - 1, 1);
  const end = new Date(y, m, 0);
  const weeks = new Map<number, { mondayOfWeek: Date }>();
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const w = isoWeek(d);
    if (!weeks.has(w)) {
      const day = (d.getDay() + 6) % 7;
      const monday = new Date(d);
      monday.setDate(d.getDate() - day);
      weeks.set(w, { mondayOfWeek: new Date(monday) });
    }
  }
  return Array.from(weeks.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([week, { mondayOfWeek }]) => {
      const sun = new Date(mondayOfWeek);
      sun.setDate(mondayOfWeek.getDate() + 6);
      const fmt = (dt: Date) => dt.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
      return { week, rangeLabel: `Week ${week} (${fmt(mondayOfWeek)}–${fmt(sun)})` };
    });
}
